const ar_pages = {
  // ── About ──────────────────────────────────────────────────────
  "about.hero.badge": "من نحن",
  "about.hero.heading": "منصة الطب الدقيق",
  "about.hero.words": "منصة الطب الدقيق|عمق سريري حقيقي|رعاية بلا حدود|نفهم قبل أن نقرر",
  "about.hero.desc": "ذا مديكال أفينيو ليست عيادة تقليدية — بل منصة طب دقيق تجمع بين العمق السريري، التقنيات المتقدمة، والامتداد الدولي",
  "about.mission.badge": "رسالتنا",
  "about.mission.heading": "نفهم قبل أن نقرر",
  "about.mission.desc": "نؤمن أن كل مريض يستحق تقييمًا حقيقيًا يفهم بيولوجيته الخاصة — لا بروتوكولًا عامًا يُطبَّق على الجميع",
  "about.mission.vision_badge": "رسالتنا ورؤيتنا",
  "about.mission.vision_title": "ما يقودنا كل يوم",
  "about.values.badge": "قيمنا",
  "about.values.heading": "المبادئ التي تحكم كل قرار",
  "about.team.badge": "فريقنا",
  "about.team.heading": "نخبة الاستشاريين",
  "about.team.desc": "كل استشاري في ذا مديكال أفينيو يجمع بين الخبرة السريرية العميقة والتدريب الدولي المتخصص",
  "about.cta.heading": "ابدأ رحلتك معنا",
  "about.cta.desc": "جلسة تقييم عميق تبني صورة واضحة عن مسارك الصحي",
  "about.cta.ready_heading": "هل أنت مستعد للفهم الحقيقي؟",
  "about.cta.ready_desc": "احجز جلسة تقييم اليوم وتعرف على الفرق الذي يصنعه الطب الدقيق في حالتك",
  "about.story.founded_year_label": "سنة التأسيس",
  "about.story.specialist_label": "استشاري متخصص",
  "about.dimensions.heading": "ثلاثة أبعاد متكاملة",
  "about.dimensions.badge": "التموضع والتميز",
  "about.dimensions.subtitle": "قوتنا التنافسية لا تقوم على الشكل، بل على البنية المتكاملة للرعاية — عمق سريري، عمق تقني، وعمق دولي",
  "about.dimensions.clinical.title": "العمق السريري",
  "about.dimensions.clinical.item1": "جلسات 90–120 دقيقة",
  "about.dimensions.clinical.item2": "تقييم غير سريع",
  "about.dimensions.clinical.item3": "فهم متعدد التخصصات",
  "about.dimensions.clinical.item4": "قراءة ما وراء العرض",
  "about.dimensions.technical.title": "العمق التقني",
  "about.dimensions.technical.item1": "DNA Risk Score",
  "about.dimensions.technical.item2": "العمر البيولوجي",
  "about.dimensions.technical.item3": "التقييم الأيضي الوظيفي",
  "about.dimensions.technical.item4": "مخاطر مستقبلية",
  "about.dimensions.international.title": "العمق الدولي",
  "about.dimensions.international.item1": "Second Opinion منظم",
  "about.dimensions.international.item2": "مراكز في USA وKorea",
  "about.dimensions.international.item3": "شبكة خبرات دولية",
  "about.dimensions.international.item4": "متابعة عابرة للحدود",
  "about.timeline.badge": "مسيرتنا",
  "about.timeline.title": "رحلة بناء منصة الطب الدقيق",
  "about.awards.badge": "إنجازاتنا",
  "about.awards.title": "الاعتمادات والشراكات",
  "about.team.view_all": "عرض جميع الاستشاريين",
  "about.team.experience": "خبرة",

  // ── Services ───────────────────────────────────────────────────
  "services.hero.badge": "خدماتنا",
  "services.hero.heading": "خدمات الطب الدقيق",
  "services.hero.words": "خدمات الطب الدقيق|عمق سريري لا مثيل له|رعاية مبنية على بيولوجيتك|نستبق قبل أن نطارد",
  "services.hero.desc": "خدمات متخصصة تجمع بين العمق السريري والتقنيات المتقدمة لبناء صورة شاملة عن مسارك الصحي",
  "services.filter.all": "الكل",
  "services.search.placeholder": "ابحث عن خدمة...",
  "services.sort.default": "الافتراضي",
  "services.sort.price_asc": "السعر: الأقل أولاً",
  "services.sort.price_desc": "السعر: الأعلى أولاً",
  "services.no_results": "لا توجد خدمات مطابقة",
  "services.from": "من",
  "services.book": "احجز الآن",
  "services.details": "التفاصيل",
  "services.cta.heading": "هل تحتاج مساعدة في الاختيار؟",
  "services.cta.desc": "فريقنا جاهز لمساعدتك في اختيار الخدمة المناسبة لحالتك",
  "services.stats.specialized": "خدمة متخصصة",
  "services.stats.duration": "دقيقة لكل جلسة",
  "services.stats.partners": "مركز دولي شريك",
  "services.stats.rating": "تقييم المرضى",
  "services.label.doctors": "أطباء",
  "services.label.procedures": "إجراءات",
  "services.why.heading": "لماذا خدماتنا مختلفة؟",
  "services.why.desc": "نجمع بين العمق السريري، الدقة التقنية، والامتداد الدولي",
  "services.why.item1.title": "جلسات 90–120 دقيقة",
  "services.why.item1.desc": "نمنح الحالة الوقت الذي تستحقه — لأن بعض الملفات لا تُفهم في دقائق",
  "services.why.item2.title": "تقنيات الطب الدقيق",
  "services.why.item2.desc": "DNA Risk Score، العمر البيولوجي، التقييم الأيضي الوظيفي",
  "services.why.item3.title": "امتداد دولي حقيقي",
  "services.why.item3.desc": "Second Opinion من مراكز في USA وKorea للحالات المعقدة",
  "services.why.item4.title": "خطة شخصية لكل حالة",
  "services.why.item4.desc": "لا بروتوكولات عامة — كل مريض يملك بيولوجيا ومسارًا مختلفًا",
  "services.cta.browse_packages": "تصفح الباقات",

  // ── Packages ───────────────────────────────────────────────────
  "packages.hero.badge": "مستويات الرعاية",
  "packages.hero.heading": "اختر مستوى التقييم المناسب لحالتك",
  "packages.hero.words": "اختر مستوى التقييم المناسب لحالتك|باقات مصممة لبيولوجيتك|رعاية متكاملة من التقييم للمتابعة|خطة شخصية لا بروتوكول عام",
  "packages.hero.desc": "من التقييم العميق الشامل إلى الرعاية الدولية المتكاملة — كل مستوى مصمم لحالة مختلفة، وكل خطة مبنية على بيولوجيتك الخاصة",
  "packages.filter.all": "الكل",
  "packages.filter.label": "تصفية الباقات",
  "packages.sort.label": "ترتيب حسب",
  "packages.price_range": "نطاق السعر",
  "packages.category": "التصنيف",
  "packages.reset": "إعادة تعيين الفلاتر",
  "packages.available": "باقة متاحة",
  "packages.single_count": "باقة",
  "packages.plural_count": "باقات",
  "packages.all_summary": "{{count}} باقة موزعة على {{catCount}} مستوى رعاية",
  "packages.cat_summary": "{{count}} باقة متاحة",
  "packages.note": "جميع الباقات تشمل ضريبة القيمة المضافة. كل خطة مبنية على التقييم الفعلي للحالة — لا بروتوكولات عامة.",
  "packages.cta.heading": "هل تحتاج مساعدة في الاختيار؟",
  "packages.cta.desc": "فريقنا من خبراء الطب الدقيق جاهز لمساعدتك في اختيار المستوى المناسب لحالتك",
  "packages.cta.book": "احجز جلسة تقييم",
  "packages.cta.contact": "تواصل معنا",
  "packages.save": "وفر",
  "packages.features_more": "مزايا أخرى",
  "packages.features_label": "{{count}} ميزة إضافية",
  "packages.category.deep_assessment": "التقييم العميق",
  "packages.category.deep_assessment.desc": "جلسات تقييم شاملة تكشف ما وراء الأعراض وتبني صورة صحية متكاملة",
  "packages.category.precision_medicine": "الطب الدقيق",
  "packages.category.precision_medicine.desc": "منصة متكاملة تجمع التقييم العميق وتحليل DNA لبناء خطة وقائية شخصية",
  "packages.category.metabolic_dysfunction": "الخلل الأيضي",
  "packages.category.metabolic_dysfunction.desc": "تقييم متخصص للسمنة وأمراض الكبد الدهني والخلل الأيضي المزمن",
  "packages.category.second_opinion": "Second Opinion",
  "packages.category.second_opinion.desc": "رأي طبي دولي من مراكز متخصصة في USA وKorea وألمانيا",
  "packages.category.genetics_dna": "الجينات والDNA",
  "packages.category.genetics_dna.desc": "تحليل جيني شامل يكشف مخاطرك الصحية المستقبلية قبل ظهورها",
  "packages.category.psychiatry": "الطب النفسي",
  "packages.category.psychiatry.desc": "تقييم نفسي عميق يدمج الجانب الجيني والمعرفي لرعاية شاملة",
  "packages.category.osteoporosis": "هشاشة العظام",
  "packages.category.osteoporosis.desc": "تقييم متخصص لكثافة العظام والمخاطر الجينية مع خطة علاجية مكثفة",
  "packages.category.iv_therapy": "العلاجات الوريدية",
  "packages.category.iv_therapy.desc": "بروتوكولات وريدية مخصصة لدعم الطاقة الخلوية والأيض والجهاز العصبي",
  "packages.category.neuro_prevention": "الوقاية العصبية",
  "packages.category.neuro_prevention.desc": "برامج وقاية متخصصة من الزهايمر والتدهور المعرفي المبكر",
  "packages.category.international_care": "الرعاية الدولية",
  "packages.category.international_care.desc": "رعاية متكاملة تجمع العمق المحلي والخبرة الدولية في منظومة واحدة",
  "packages.category.vip": "VIP",
  "packages.category.vip.desc": "تجربة طبية استثنائية بأعلى مستويات الخصوصية والرعاية الشخصية",

  // ── Doctors ────────────────────────────────────────────────────
  "doctors.cta.join_heading":"تواصل معنا",
  "doctors.cta.join_desc":"تعرف على الأطباء المتخصصين في ذا مديكال أفينيو",
  "home.why.clinical_depth":"ليه تختارنا؟",
  "doctors.hero.badge": "الاستشاريون",
  "doctors.hero.heading": "استشاريو ذا مديكال أفينيو",
  "doctors.hero.words": "استشاريو ذا مديكال أفينيو|خبراء الطب الدقيق|نخبة المتخصصين|كفاءة سريرية عالية",
  "doctors.hero.desc": "نخبة من الاستشاريين المتخصصين يجمعون بين الخبرة السريرية العميقة والتدريب الدولي المتخصص",
  "doctors.filter.all": "الكل",
  "doctors.search.placeholder": "ابحث بالاسم أو التخصص...",
  "doctors.no_results": "لا يوجد أطباء مطابقون",
  "doctors.book": "احجز استشارة",
  "doctors.profile": "الملف الشخصي",
  "doctors.fee": "رسوم الاستشارة",
  "doctors.experience": "سنوات الخبرة",
  "doctors.available": "متاح للحجز",
  "doctors.specialty.precision": "الطب الدقيق وتقييم المخاطر",
  "doctors.specialty.metabolic": "الخلل الأيضي وMASLD",
  "doctors.specialty.psychiatry": "الطب النفسي للبالغين",
  "doctors.specialty.genetics": "الجينات والطب الدقيق",
  "doctors.specialty.osteoporosis": "هشاشة العظام المكثفة",
  "doctors.specialty.iv": "العلاجات الوريدية المتخصصة",

  // ── Contact ────────────────────────────────────────────────────
  "contact.hero.badge": "تواصل معنا",
  "contact.hero.heading": "نحن هنا لمساعدتك",
  "contact.hero.words": "نحن هنا لمساعدتك|فريقك الطبي المتخصص|نرد في أقل من ساعة|تواصل بثقة",
  "contact.hero.desc": "فريقنا جاهز للإجابة على استفساراتك ومساعدتك في اختيار الخدمة المناسبة",
  "contact.form.name": "الاسم الكامل",
  "contact.form.email": "البريد الإلكتروني",
  "contact.form.phone": "رقم الجوال",
  "contact.form.subject": "الموضوع",
  "contact.form.message": "رسالتك",
  "contact.form.submit": "إرسال الرسالة",
  "contact.form.success": "تم إرسال رسالتك بنجاح!",
  "contact.info.address": "العنوان",
  "contact.info.phone": "الهاتف",
  "contact.info.email": "البريد الإلكتروني",
  "contact.info.hours": "ساعات العمل",
  "contact.form.send_message": "أرسل رسالة",
  "contact.form.send_another": "إرسال رسالة أخرى",
  "contact.form.select_subject": "اختر موضوع الرسالة...",
  "contact.form.max_chars": "الحد الأقصى {{count}} حرف",
  "contact.form.error_msg": "حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى.",
  "contact.form.sending": "جاري الإرسال...",
  "contact.info.working_days": "السبت - الخميس",
  "contact.info.friday": "الجمعة",
  "contact.info.follow_us": "تابعنا على",
  "contact.dna.title": "الطب الدقيق والـ DNA",
  "contact.dna.description": "للاستفسار عن تحليل DNA Risk Score أو تقييم العمر البيولوجي أو الرأي الطبي الدولي، يُرجى ذكر ذلك في موضوع رسالتك.",

  // ── Blog ───────────────────────────────────────────────────────
  "blog.hero.badge": "مدونة الطب الدقيق",
  "blog.hero.heading": "معرفة أعمق قرار أدق",
  "blog.hero.words": "معرفة أعمق، قرار أدق|علم يخدم قرارك الصحي|محتوى من خبراء حقيقيين|نكتب لنفهم، لا لنبهر",
  "blog.hero.desc": "محتوى علمي متخصص من استشاريي ذا مديكال أفينيو — في الطب الدقيق، تحليل DNA، الخلل الأيضي، والرعاية التخصصية المتقدمة",
  "blog.filter.all": "الكل",
  "blog.search.placeholder": "ابحث في مقالات الطب الدقيق...",
  "blog.read_more": "اقرأ المزيد",
  "blog.min_read": "دقيقة قراءة",
  "blog.no_results": "لا توجد مقالات مطابقة",
  "blog.related": "مقالات ذات صلة",
  "blog.stats.articles": "مقال متخصص",
  "blog.stats.authors": "استشاري مؤلف",
  "blog.stats.reads": "قراءة شهرياً",
  "blog.featured_articles": "المقالات المميزة",
  "blog.exclusive": "محتوى حصري",
  "blog.featured_badge": "مميز",
  "blog.read": "قراءة",
  "blog.search_results_for": "نتائج البحث عن:",
  "blog.article_count": "مقال",
  "blog.all_articles": "جميع المقالات",
  "blog.try_different_search": "جرب كلمات بحث مختلفة أو تصنيفاً آخر",
  "blog.philosophy_badge": "فلسفة المحتوى",
  "blog.philosophy_heading": "نكتب لنفهم، لا لنبهر",
  "blog.philosophy_desc": "كل مقال في مدونتنا يخدم هدفاً واحداً: مساعدتك على فهم حالتك الصحية بعمق أكبر",
  "blog.pillar1_title": "عمق سريري",
  "blog.pillar1_desc": "مقالات تفكك الحالة وتربط بين الحاضر الصحي والمخاطر المستقبلية — لا مجرد نصائح عامة",
  "blog.pillar2_title": "عمق تقني",
  "blog.pillar2_desc": "محتوى يشرح تقنيات الطب الدقيق كـ DNA Risk Score والعمر البيولوجي بلغة واضحة وعلمية",
  "blog.pillar3_title": "عمق دولي",
  "blog.pillar3_desc": "رؤى مستمدة من شبكة خبراتنا في USA وكوريا الجنوبية وأبرز مراكز الطب الدقيق عالمياً",
  "blog.newsletter_heading": "اشترك في نشرة الطب الدقيق",
  "blog.newsletter_desc": "احصل على أحدث مقالات الطب الدقيق، تحليل DNA، وإدارة المخاطر الصحية — مباشرة في بريدك الإلكتروني",
  "blog.newsletter_email_placeholder": "بريدك الإلكتروني",
  "blog.newsletter_submit": "اشترك الآن",
  "blog.newsletter_note": "لا رسائل مزعجة — يمكنك إلغاء الاشتراك في أي وقت",
  "blog.detail.personal_evaluation_prompt": "هل تريد تقييماً شخصياً؟",
  "blog.detail.personal_evaluation_desc": "ما تقرأه هنا هو مقدمة علمية. التقييم الحقيقي يبدأ بجلسة عميقة مع أحد استشاريينا — نفهم حالتك الخاصة قبل أن نقترح أي خطة.",
  "blog.detail.share_article": "شارك هذا المقال:",
  "blog.detail.copy_link": "نسخ الرابط",
  "blog.detail.view_full_profile": "عرض الملف الكامل",
  "blog.detail.author_bio": "استشاري متخصص في ذا مديكال أفينيو — منصة الطب الدقيق والرعاية التخصصية المتقدمة. يؤمن بأن الفهم العميق للحالة هو أساس أي قرار طبي صحيح.",
  "blog.detail.sidebar_book_desc": "تحدث مع أحد استشاريينا حول ما قرأته — التقييم العميق يبدأ من هنا",
  "blog.detail.view_care_levels": "استعرض مستويات الرعاية",
  "blog.detail.dimensions_title": "أبعاد الطب الدقيق",
  "blog.detail.clinical_depth_sub": "جلسات 90–120 دقيقة",
  "blog.detail.technical_depth_sub": "DNA، عمر بيولوجي، مخاطر",
  "blog.detail.international_depth_sub": "USA وكوريا الجنوبية",
  "blog.detail.view_all_articles": "عرض جميع المقالات",
  "blog.detail.related_services": "خدمات ذات صلة",
  "blog.detail.related_service_1": "تقييم المخاطر الصحية",
  "blog.detail.related_service_2": "DNA Risk Score",
  "blog.detail.related_service_3": "Second Opinion الدولي",
  "blog.detail.related_service_4": "مستويات الرعاية",
  "blog.detail.other_articles": "مقالات أخرى",
  "blog.detail.view_all": "عرض الكل",
  "blog.views": "مشاهدة",

  // ── FAQ ────────────────────────────────────────────────────────
  "faq.hero.badge": "الأسئلة الشائعة",
  "faq.hero.heading": "كيف يمكننا مساعدتك؟",
  "faq.hero.words": "كيف يمكننا مساعدتك؟|إجابات واضحة|لا سؤال بلا جواب|نوضح قبل أن تسأل",
  "faq.hero.desc": "إجابات واضحة على أكثر الأسئلة شيوعاً حول خدماتنا وطريقة عملنا",
  "faq.search.placeholder": "ابحث في الأسئلة...",
  "faq.no_results": "لا توجد أسئلة مطابقة",
  "faq.still_have": "لا تزال لديك أسئلة؟",
  "faq.contact_us": "تواصل مع فريقنا",

  // ── DNA Simulator ──────────────────────────────────────────────
  "dna.hero.badge": "أداة تفاعلية مجانية",
  "dna.hero.heading": "DNA Risk Score",
  "dna.hero.subheading": "اكتشف مستوى مخاطرك الصحية المستقبلية",
  "dna.hero.desc": "10 أسئلة تفاعلية تحلل عوامل الخطر الجينية والبيئية لديك — وتوصيك بالباقة الأنسب لمسارك الصحي",
  "dna.hero.btn_start": "ابدأ التقييم الآن — مجاناً",
  "dna.hero.btn_service": "تعرف على DNA Risk Score الحقيقي",
  "dna.stats.questions": "أسئلة فقط",
  "dna.stats.categories": "مجالات صحية",
  "dna.stats.free": "مجاني",
  "dna.how.badge": "كيف يعمل التقييم؟",
  "dna.how.heading": "كيف يعمل التقييم؟",
  "dna.how.desc": "نحلل عوامل الخطر الرئيسية لديك ونبني صورة تقديرية عن مستوى مخاطرك الصحية المستقبلية",
  "dna.how.step1_title": "أجب على 10 أسئلة",
  "dna.how.step1_desc": "أسئلة تغطي التاريخ العائلي، نمط الحياة، الأعراض الحالية، والعوامل البيئية",
  "dna.how.step2_title": "نحلل مخاطرك",
  "dna.how.step2_desc": "خوارزمية تحليل تقيّم 5 مجالات صحية رئيسية وتحسب مستوى المخاطر الإجمالي",
  "dna.how.step3_title": "توصية شخصية",
  "dna.how.step3_desc": "نوصيك بالباقة الأنسب لمستوى مخاطرك مع رابط مباشر للحجز",
  "dna.categories.heading": "المجالات الصحية التي نقيّمها",
  "dna.btn.start": "ابدأ تقييم DNA Risk Score",
  "dna.btn.free_note": "مجاني تماماً · لا يتطلب تسجيل · نتائج فورية",
  "dna.result.heading": "نتائج تقييم DNA Risk Score",
  "dna.result.desc": "بناءً على إجاباتك، هذا تقييمنا التقديري لمستوى مخاطرك الصحية",
  "dna.result.analyzed": "تم تحليل إجاباتك",
  "dna.result.overall": "مستوى المخاطر الإجمالي",
  "dna.result.breakdown": "تفصيل المخاطر حسب المجال",
  "dna.result.detail": "تحليل المخاطر التفصيلي",
  "dna.result.recommended": "الباقة الموصى بها لحالتك",
  "dna.result.recommended_desc": "بناءً على إجاباتك، هذه الباقات الأنسب لمستوى مخاطرك",
  "dna.result.best_fit": "الأنسب لحالتك",
  "dna.result.disclaimer": "هذا التقييم تقديري ومبني على إجاباتك — لا يُغني عن التقييم السريري الفعلي مع استشاري متخصص.",
  "dna.result.book_real": "احجز تقييمًا حقيقيًا مع استشاري",
  "dna.result.retake": "إعادة التقييم",
  "dna.cta.heading": "هل تريد تقييمًا جينيًا حقيقيًا؟",
  "dna.cta.desc": "DNA Risk Score الحقيقي يتطلب تحليلًا جينيًا مخبريًا دقيقًا — احجز جلسة مع استشاريينا لبدء رحلتك",
  "dna.cta.btn_book": "احجز جلسة DNA Risk Score",
  "dna.cta.btn_service": "تعرف على الخدمة",

  // ── Offers ─────────────────────────────────────────────────────
  "offers.hero.badge": "العروض الحالية",
  "offers.hero.heading": "عروض حصرية لفترة محدودة",
  "offers.hero.desc": "استفد من عروضنا الحصرية على باقات الطب الدقيق والتقييم الشامل",
  "offers.valid_until": "صالح حتى",
  "offers.book": "احجز بالسعر المخفض",
  "offers.save": "وفر",
  "offers.limited": "عرض محدود",
  "doctors.profile.not_found": "لم يتم العثور على الطبيب",
  "doctors.profile.back": "العودة للأطباء",
  "doctors.profile.reviews": "تقييم",
  "doctors.profile.book_appointment": "احجز موعداً",
  "doctors.profile.languages": "اللغات",
  "doctors.profile.working_days": "أيام العمل",
  "doctors.profile.days_per_week": "{{count}} أيام/أسبوع",
  "doctors.profile.working_days_title": "أيام الدوام:",
  "doctors.profile.qualifications": "المؤهلات العلمية",
  "doctors.profile.achievements": "الإنجازات والشهادات",
  "doctors.profile.specializations": "مجالات التخصص",
  "doctors.profile.other_doctors": "أطباء آخرون قد يهمك",
  "doctors.profile.booking_cta_title": "هل تريد حجز موعد مع {{name}}؟",
  "doctors.profile.booking_cta_desc": "احجز موعدك الآن وسنتواصل معك لتأكيد الموعد",
  "doctors.profile.book_now_btn": "احجز موعداً الآن",
  "doctors.tab.about": "نبذة عن الطبيب",
  "doctors.tab.specializations": "التخصصات والإنجازات",
  "doctors.tab.reviews": "آراء المرضى",
  "doctors.tab.calendar": "المواعيد المتاحة",
  "services.detail.not_found": "الخدمة غير موجودة",
  "services.detail.back": "العودة للخدمات",
  "services.detail.platform_badge": "منصة الطب الدقيق",
  "services.detail.depth.clinical": "عمق سريري",
  "services.detail.depth.technical": "عمق تقني",
  "services.detail.depth.international": "عمق دولي",
  "services.detail.book.title": "احجز موعدك الآن",
  "services.detail.book.start_price": "الأسعار تبدأ من",
  "services.detail.book.btn": "احجز موعداً",
  "services.detail.book.whatsapp": "استفسر عبر واتساب",
  "services.detail.book.quality": "ضمان جودة الخدمة",
  "services.detail.book.hours": "جلسات 90–120 دقيقة",
  "services.detail.book.report": "تقرير إلكتروني مفصل",
  "services.detail.about": "عن هذه الخدمة",
  "services.detail.procedures": "الإجراءات والفحوصات المتاحة",
  "services.detail.prices": "الأسعار والتعرفة",
  "services.detail.prices.vat_note": "جميع الأسعار شاملة ضريبة القيمة المضافة. قد تختلف الأسعار حسب الحالة. تواصل معنا للاستفسار.",
  "services.detail.doctors": "الاستشاريون المتخصصون",
  "services.detail.faqs": "الأسئلة الشائعة",
  "services.detail.cta.heading": "جاهز لتقييم عميق الحقيقي؟",
  "services.detail.cta.desc": "فريقنا من خبراء الطب الدقيق في {{name}} جاهز لمنح حالتك الوقت والعمق الذي تستحقه",
  "services.detail.quick_book": "حجز سريع",
  "services.detail.whatsapp_label": "واتساب",
  "services.detail.related": "خدمات ذات صلة",
  "services.detail.why_us": "لماذا ذا مديكال أفينيو؟",
  "services.detail.dimensions.title": "ثلاثة أبعاد متكاملة للرعاية",
  "services.detail.dimensions.desc": "ما يميز ذا مديكال أفينيو عن أي عيادة تقليدية",
  "services.detail.methodology.badge": "منهجية ذا مديكال أفينيو",
  "services.detail.methodology.title": "كيف نعمل — منهجية التقييم العميق",
  "services.detail.methodology.desc": "لسنا عيادة تتعامل مع الشكوى فقط — نفكك الحالة ونقرأ ما وراء العرض، ونربط بين الحاضر الصحي والمخاطر المستقبلية",
  "services.detail.methodology.step_prefix": "الخطوة",
  "services.detail.methodology.full_btn": "عرض المنهجية الكاملة",
  "services.detail.methodology.step1.title": "الاستماع العميق",
  "services.detail.methodology.step1.desc": "نبدأ بجلسة استماع مطوّلة تتجاوز الشكوى الرئيسية — نفهم التاريخ الصحي الكامل، نمط الحياة، العوامل الوراثية، والسياق النفسي والاجتماعي.",
  "services.detail.methodology.step1.duration": "30–45 دقيقة",
  "services.detail.methodology.step1.tag": "العمق السريري",
  "services.detail.methodology.step2.title": "التقييم متعدد الطبقات",
  "services.detail.methodology.step2.desc": "نفكك الحالة عبر طبقات متعددة: السريرية، المخبرية، الوظيفية، والجينية. لا نكتفي بما يظهر — نقرأ ما وراء العرض.",
  "services.detail.methodology.step2.duration": "60–90 دقيقة",
  "services.detail.methodology.step2.tag": "العمق التقني",
  "services.detail.methodology.step3.title": "قراءة المخاطر المستقبلية",
  "services.detail.methodology.step3.desc": "نربط بين الحاضر الصحي والمخاطر المستقبلية. نستخدم DNA Risk Score، المؤشرات الأيضية، والعمر البيولوجي لبناء صورة استباقية شاملة.",
  "services.detail.methodology.step3.duration": "تحليل متكامل",
  "services.detail.methodology.step3.tag": "الطب الدقيق",
  "services.detail.methodology.step4.title": "الاستشارة الدولية عند الحاجة",
  "services.detail.methodology.step4.desc": "للحالات المعقدة، نستعين بشبكتنا الدولية في الولايات المتحدة وجنوب كوريا وغيرها. Second Opinion منظم لا شكلي.",
  "services.detail.methodology.step4.duration": "7–14 يوم",
  "services.detail.methodology.step4.tag": "العمق الدولي",
  "services.detail.methodology.step5.title": "الخطة الشخصية",
  "services.detail.methodology.step5.desc": "نصمم خطة علاجية مبنية على بيولوجيا المريض ومساره الصحي الفريد — لا بروتوكولات عامة، بل قرار طبي مخصص.",
  "services.detail.methodology.step5.duration": "جلسة تفسير",
  "services.detail.methodology.step5.tag": "التخصيص",
  "services.detail.methodology.step6.title": "المتابعة اللصيقة",
  "services.detail.methodology.step6.desc": "رعايتنا لا تنتهي عند التشخيص. نتابع المؤشرات، نعدّل الخطة، ونبقى على تواصل مستمر مع المريض عبر التطبيق والزيارات الدورية.",
  "services.detail.methodology.step6.duration": "مستمر",
  "services.detail.methodology.step6.tag": "الاستمرارية",
  "services.detail.quote": "نفهم قبل أن نقرر — نحلل قبل أن نتدخل — نستبق قبل أن نطارد",
  "services.detail.philosophy_title": "فلسفة ذا مديكال أفينيو في الطب الدقيق",
  "packages.philosophy.title": "فلسفتنا في الرعاية",
  "packages.philosophy.desc": "أربعة مبادئ تحكم كل باقة نقدمها",
  "packages.detail.feature": "الميزة",
  "packages.detail.current": "الباقة الحالية",
  "packages.detail.total_price": "السعر الإجمالي",
  "packages.detail.book_now": "احجز الباقة الآن",
  "packages.detail.not_found": "الباقة غير موجودة",
  "packages.detail.back": "العودة للباقات",
  "packages.detail.original_price": "السعر الأصلي",
  "packages.detail.preparation": "إرشادات التحضير",
  "packages.detail.includes": "محتويات الباقة",
  "packages.detail.comparison": "مقارنة الباقات",
  "packages.detail.trust.title": "خدمة طبية موثوقة بالكامل",
  "packages.detail.trust.desc": "جميع باقاتنا تقدم تحت إشراف نخبة من الاستشاريين المتخصصين مع ضمان أعلى معايير الجودة والسرية",
  "packages.detail.preparation.default_desc": "يرجى اتباع هذه الإرشادات البسيطة لضمان الحصول على أدق النتائج للفحوصات المخبرية وجلسة التقييم الخاصة بك",
  "packages.tab.overview": "نظرة عامة",
  "packages.tab.includes": "ما تشمله الباقة",
  "packages.tab.preparation": "إرشادات التحضير",
  "packages.tab.compare": "مقارنة الباقات",
  "packages.tab.faq": "الأسئلة الشائعة",
  "packages.detail.target_title": "لمن هذه الباقة؟",
  "packages.detail.components_title": "مكونات الباقة",
  "packages.detail.components_count": "{{count}} عنصر",
  "packages.detail.compare_title": "قارن مع باقات {{category}}",
  "packages.detail.compare_desc": "{{count}} باقة أخرى في نفس المستوى — اختر الأنسب لك",
  "packages.detail.view_compare": "عرض المقارنة",
  "packages.detail.main_services": "الخدمات الرئيسية",
  "packages.detail.full_list": "قائمة المكونات الكاملة",
  "packages.detail.how_prep": "كيف تستعد للفحص؟",
  "packages.detail.important_alert": "تنبيه مهم",
  "packages.detail.important_alert_desc": "في حال وجود أي حالة طبية خاصة أو أدوية تتناولها، يُرجى إبلاغ الفريق الطبي قبل الجلسة.",
  "packages.detail.compare_level": "مقارنة باقات {{category}}",
  "packages.detail.compare_level_desc": "قارن بين جميع الباقات المتاحة في مستوى \"{{category}}\" واختر الأنسب لاحتياجاتك",
  "packages.detail.other_packages": "باقات أخرى في نفس المستوى",
  "packages.detail.questions_count": "{{count}} سؤال",
  "packages.detail.have_other_q": "لديك سؤال آخر؟",
  "packages.detail.have_other_q_desc": "فريقنا جاهز للإجابة على جميع استفساراتك",
  "packages.detail.ready_book": "جاهز للحجز؟",
  "packages.detail.ready_book_desc": "احجز الآن وابدأ رحلتك نحو صحة أفضل",
  "packages.detail.price_label": "سعر الباقة",
  "packages.detail.duration_label": "المدة",
  "packages.detail.choose_best": "اختر الباقة الأنسب لاحتياجاتك",
  "packages.detail.have_inquiry": "هل لديك استفسار؟",
  "offers.countdown.days": "يوم",
  "offers.countdown.hours": "ساعة",
  "offers.countdown.minutes": "دقيقة",
  "offers.countdown.seconds": "ثانية",
  "offers.discount_badge": "خصم {{percent}}%",
  "offers.save_label": "وفر {{amount}} ر",
  "offers.book_discounted": "احجز بالسعر المخفض",
  "offers.exclusive_discount": "خصم حصري",
  "offers.packages_count": "على {{count}} باقة مختارة",
  "offers.ends_in": "ينتهي العرض خلال",
  "offers.all_offers": "جميع العروض",
  "offers.stats.savings": "إجمالي التوفير",
  "offers.stats.savings.desc": "على جميع الباقات المشمولة",
  "offers.stats.ends_soon": "أقرب عرض ينتهي",
  "offers.stats.ends_soon.desc": "بادر بالحجز قبل الفوات",
  "offers.stats.packages": "باقة مشمولة",
  "offers.stats.packages.desc": "بخصومات مميزة",
  "offers.stats.guarantee": "جودة طبية",
  "offers.stats.guarantee.desc": "تحت إشراف استشاريين",
  "offers.coupon.title": "رمز الخصم الحصري",
  "offers.coupon.desc": "انسخ الرمز واستخدمه في صفحة الحجز للحصول على خصم إضافي",
  "offers.coupon.copy": "نسخ الرمز",
  "offers.coupon.copied": "تم نسخ الرمز",
  "offers.notify.title": "اشترك لتصلك العروض الحصرية",
  "offers.notify.desc": "لا تفوت عروض الطب الدقيق والباقات الموسمية المخصصة لبيولوجيتك",
  "offers.notify.email_placeholder": "بريدك الإلكتروني...",
  "offers.notify.subscribe": "اشترك الآن",
  "offers.notify.success": "تم اشتراكك بنجاح!",
  "offers.stats.active": "عروض موسمية نشطة",
  "offers.stats.packages_active": "باقة مشمولة بالعروض",
  "offers.stats.highest": "أعلى نسبة خصم",
  "offers.stats.total_savings": "ريال توفير إجمالي",
  "offers.flash_sale": "فلاش سيل",
  "offers.limited_time": "عروض محدودة الوقت",
  "offers.limited_time_desc": "تنتهي قريباً — لا تفوّت الفرصة!",
  "offers.seasonal_badge": "عروض موسمية",
  "offers.seasonal_title": "العروض الموسمية الحالية",
  "offers.how_redeem": "كيف تستفيد من العروض؟",
  "offers.how_redeem_desc": "خطوات بسيطة للحصول على خصمك",
  "faq.qa_label": "سؤال وجواب",
  "faq.response_time": "وقت الرد",
  "faq.support_24_7": "دعم متواصل",
  "faq.categories_title": "التصنيفات",
  "faq.all_questions": "جميع الأسئلة",
  "faq.call_directly": "اتصل بنا مباشرة",
  "faq.search_results": "نتائج البحث عن:",
  "faq.search_results_count": "({{count}} نتيجة)",
  "faq.no_results_desc": "جرب كلمات بحث مختلفة أو تواصل معنا مباشرة",
  "faq.still_have_desc": "فريق خبراء الطب الدقيق لدينا متاح للإجابة على جميع استفساراتك — سواء حول التقييم العميق أو تحليل DNA أو الرأي الطبي الدولي",
  "faq.send_message": "أرسل رسالة",
  "faq.cta.precision_platform": "منصة الطب الدقيق",
  "faq.cta.card1_title": "تقييم عميق متعدد الطبقات",
  "faq.cta.card1_desc": "جلسات 90–120 دقيقة لفهم الحالة بالكامل قبل أي قرار",
  "faq.cta.card2_title": "تحليل DNA والمخاطر المستقبلية",
  "faq.cta.card2_desc": "نقرأ استعداداتك الجينية لنستبق المخاطر قبل أن تتحول إلى واقع",
  "faq.cta.card3_title": "امتداد دولي عند الحاجة",
  "faq.cta.card3_desc": "شبكة خبرات في USA وكوريا الجنوبية للحالات التي تحتاج منظوراً أوسع",
  "dna.ai.urgency.low": "إلحاح منخفض",
  "dna.ai.urgency.medium": "إلحاح متوسط",
  "dna.ai.urgency.high": "إلحاح مرتفع",
  "dna.ai.urgency.critical": "إلحاح حرج",
  "dna.ai.report_title": "التقرير الذكي بالذكاء الاصطناعي",
  "dna.ai.report_desc": "احصل على تقرير طبي شخصي مفصل مكتوب بالذكاء الاصطناعي",
  "dna.ai.includes": "ما يتضمنه التقرير:",
  "dna.ai.includes.item1": "ملخص تنفيذي لحالتك الصحية",
  "dna.ai.includes.item2": "تحليل المخاطر الرئيسية مع تفسير",
  "dna.ai.includes.item3": "توصيات طبية عملية مخصصة",
  "dna.ai.includes.item4": "خطوات فورية للمتابعة",
  "dna.ai.includes.item5": "تقييم مستوى الإلحاح",
  "dna.ai.generate_btn": "إنشاء التقرير الذكي",
  "dna.ai.generating": "جاري كتابة التقرير الذكي...",
  "dna.ai.loading_desc": "جاري تحليل بياناتك...",
  "dna.ai.loading_sub": "الذكاء الاصطناعي يكتب تقريرك الطبي الشخصي",
  "dna.ai.medical_report": "التقرير الطبي الذكي",
  "dna.ai.medical_report_desc": "مكتوب بالذكاء الاصطناعي بناءً على إجاباتك",
  "dna.ai.rec_title": "التوصيات الطبية",
  "dna.ai.next_steps": "الخطوات التالية",
  "dna.ai.disclaimer": "هذا التقرير مولد بالذكاء الاصطناعي ولا يُغني عن استشارة طبية",
  "dna.ai.regenerate": "إعادة إنشاء",
  "dna.risk.low": "منخفض",
  "dna.risk.low_desc": "مخاطرك الصحية منخفضة — الوقاية المبكرة تحافظ على هذا المستوى",
  "dna.risk.medium": "متوسط",
  "dna.risk.medium_desc": "هناك عوامل خطر تستحق التقييم الدقيق والمتابعة المنتظمة",
  "dna.risk.high": "مرتفع",
  "dna.risk.high_desc": "مستوى المخاطر يستدعي تقييمًا عميقًا وخطة وقائية شخصية",
  "dna.risk.critical": "مرتفع جداً",
  "dna.risk.critical_desc": "التدخل المبكر ضروري — التقييم الشامل يمكّنك من استباق المخاطر",
  "dna.result.suitability": "الأنسب لحالتك",
  "dna.result.recommend_title": "الباقة الموصى بها لحالتك",
  "dna.result.recommend_desc": "بناءً على إجاباتك، هذه الباقات الأنسب لمستوى مخاطرك",
  "dna.result.disclaimer_desc": "هذا التقييم تقديري ومبني على إجاباتك — لا يُغني عن التقييم السريري الفعلي مع استشاري متخصص. DNA Risk Score الحقيقي يتطلب تحليلًا جينيًا مخبريًا دقيقًا.",
  "dna.result.cardiac": "القلب والأوعية",
  "dna.result.metabolic": "الأيض والسكري",
  "dna.result.neuro": "الجهاز العصبي",
  "dna.result.bone": "العظام والمفاصل",
  "dna.result.mental": "الصحة النفسية",
  "dna.result.risk_platform": "التقييم الجيني والمخاطر",
  "dna.result.early_change": "التقييم المبكر يغير المسار",
  "dna.result.genes_destiny": "الجينات ليست مصيرًا",
  "dna.result.detailed_analysis": "تحليل المخاطر التفصيلي",
  "dna.result.book_consultant": "احجز تقييمًا حقيقيًا مع استشاري",
  "dna.q.question_label": "سؤال",
  "dna.q.of_label": "من",
  "dna.q.multiselect_label": "يمكن اختيار أكثر من إجابة",
  "dna.q.singleselect_label": "اختر إجابة واحدة",
  "dna.intro.badge": "أداة تفاعلية مجانية",
  "dna.intro.title": "اكتشف مستوى مخاطرك الصحية المستقبلية",
  "dna.intro.desc": "10 أسئلة تفاعلية تحلل عوامل الخطر الجينية والبيئية لديك — وتوصيك بالباقة الأنسب لمسارك الصحي",
  "dna.intro.start": "ابدأ التقييم الآن — مجاناً",
  "dna.intro.learn_more": "تعرف على DNA Risk Score الحقيقي",
  "dna.intro.how_works": "كيف يعمل التقييم؟",
  "dna.intro.how_works_desc": "نحلل عوامل الخطر الرئيسية لديك ونبني صورة تقديرية عن مستوى مخاطرك الصحية المستقبلية",
  "dna.intro.step1_title": "أجب على 10 أسئلة",
  "dna.intro.step1_desc": "أسئلة تغطي التاريخ العائلي، نمط الحياة، الأعراض الحالية، والعوامل البيئية",
  "dna.intro.step2_title": "نحلل مخاطرك",
  "dna.intro.step2_desc": "خوارزمية تحليل تقيّم 5 مجالات صحية رئيسية وتحسب مستوى المخاطر الإجمالي",
  "dna.intro.step3_title": "توصية شخصية",
  "dna.intro.step3_desc": "نوصيك بالباقة الأنسب لمستوى مخاطرك مع رابط مباشر للحجز",
  "dna.intro.eval_title": "المجالات الصحية التي نقيّمها",
  "dna.intro.start_btn": "ابدأ تقييم DNA Risk Score",
  "dna.intro.free_note": "مجاني تماماً · لا يتطلب تسجيل · نتائج فورية",
  "dna.quiz.progress_completed": "مكتمل",
  "dna.quiz.prev": "السابق",
  "dna.quiz.next": "التالي",
  "dna.quiz.show_results": "عرض النتائج",
  "dna.result.hero_title": "نتائج تقييم DNA Risk Score",
  "dna.result.hero_desc": "بناءً على إجاباتك، هذا تقييمنا التقديري لمستوى مخاطرك الصحية",
  "dna.bottom.title": "هل تريد تقييمًا جينيًا حقيقيًا؟",
  "dna.bottom.desc": "DNA Risk Score الحقيقي يتطلب تحليلًا جينيًا مخبريًا دقيقًا — احجز جلسة مع استشاريينا لبدء رحلتك",
  "dna.bottom.book": "احجز جلسة DNA Risk Score",
  "dna.bottom.learn": "تعرف على الخدمة",
};

export default ar_pages;
